/** A counter login shares this browser with the customer site. Only a customer token may skip the address form. */
export function isCustomerBookingToken(token) {
    if (!token || typeof token !== 'string') return false;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (!payload.exp || payload.exp * 1000 <= Date.now()) return false;
        if (payload.role && payload.role !== 'customer') return false;
        return true;
    } catch (e) {
        return false;
    }
}

/** True when a saved return path is the public homepage, not an order step. */
export function isPublicHomePath(path, laundryId) {
    if (!path || typeof path !== 'string') return false;
    const bare = path.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
    if (bare === '/' || bare === '/invalid') return true;
    if (laundryId && bare === `/${laundryId}/site`) return true;
    return /^\/[^/]+\/site$/.test(bare);
}

/**
 * Where a customer who asked to schedule should go next.
 * A saved path back to the marketing homepage is dropped.
 */
export function bookingDestination(path, laundryId, fallback) {
    const home = fallback || (laundryId ? `/${laundryId}/user/schedule-order` : '/');
    if (!path || isPublicHomePath(path, laundryId)) return home;
    return path;
}
